<template>
  <div>
    <!-- spinner -->
    <div class="text-center">
      <v-overlay :value="dialog_loader">
        <v-progress-circular
          :size="90"
          :width="7"
          color="#32B1EE"
          indeterminate
          dark
        ></v-progress-circular>
      </v-overlay>
    </div>
    <!-- spinner -->

    <v-content style="background-color: #eff6fc;">
      <v-container fill-height fluid>
        <v-row justify="center" align="center">
          <v-col cols="12">
            <v-card
              elevation="0"
              class="mx-auto"
              max-width="1000"
              style="background-color: #eff6fc; min-height: 100vh;"
            >
              <v-card-title style="color: white; background: #32b1ee">
                เลือกโรงพยาบาลหรือคลินิก
              </v-card-title>
              <v-container class="pt-4">
                <v-autocomplete
                  clearable
                  v-model="clinic"
                  :items="item_hospital"
                  outlined
                  dense
                  @input="getHospital(item)"
                  item-text="first_name_th"
                  item-value="first_name_th"
                  label="ค้นหาโรงพยาบาลหรือคลินิก"
                >
                  <template slot="no-data">
                    <span class="pl-2">ไม่พบโรงพยาบาลหรือคลินิก</span>
                  </template>
                </v-autocomplete>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    sm="6"
                    lg="4"
                    v-for="(clinic, index) in item_hospital"
                    :key="index"
                  >
                    <v-card
                      elevation="5"
                      @click="next_step_reserve(clinic)"
                      style="border-radius: 10px"
                    >
                      <v-img
                        class="ma-2"
                        v-if="clinic.organize_logo"
                        height="200"
                        :src="clinic.organize_logo"
                      ></v-img>
                      <v-img
                        v-else
                        height="200"
                        :src="require(`@/assets/image/Frame 6.png`)"
                      ></v-img>
                      <v-container style="background-color: rgba(50, 177, 238, 0.5);">
                        <h4>
                          <!-- ชื่อ : -->
                          {{
                            clinic.first_name_th ? clinic.first_name_th : "-"
                          }}
                        </h4>
                        <p style="font-size:18px" class="mb-0">
                          {{ clinic.first_name_eng	 }}
                        </p>
                        <p style="font-size: 14px; color: #5B5B5B" class="mb-0">
                          ที่อยู่ :
                          {{
                            clinic.organize_location		
                              ? clinic.organize_location		
                              : "-"
                          }}
                        </p>
                        <p style="font-size: 14px; color: #5B5B5B" class="mb-0">
                          หมายเลขโทรศัพท์ :
                          {{
                            clinic.organize_phone	
                              ? clinic.organize_phone	
                              : "-"
                          }}
                        </p>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <ConsentBot ref="dialogConsent" :item="itemConsent" />
    </v-content>
  </div>
</template>

<script>
import liff from "@line/liff";
import Swal from "sweetalert2";
import get_access_token from "@/services/get_access_token";
import ConsentBot from "@/components/ConsentBot.vue";
export default {
  components: {
    ConsentBot,
  },
  data() {
    return {
      itemConsent: {
        business_id:
          this.$route.query["biz_id"] || this.$route.query["business_id"],
        share_token: this.$route.query.share_token || "",
      },
      dialog_loader: false,
      share_token: "",
      clinic: "",
      item_clinic: [],
      select_clinic: [],
      item_hospital: [],
      profile: null,
      check_patient: false,
      liff_id: "",
    };
  },
  watch: {
    clinic(val) {
      this.select_clinic = [];
      for (let index = 0; index < this.item_hospital.length; index++) {
        if (val == this.item_hospital[index].hospital.first_name_th) {
          this.select_clinic.push(this.item_hospital[index]);
        } else if (val == null) {
          this.select_clinic = this.item_hospital;
        }
      }
    },
  },
  async mounted() {
    this.dialog_loader = true;
    if (this.$route.query.type == "appointment") {
      this.liff_id = process.env.VUE_APP_LIFF_ID_APPOINTMENT;
      await this.initLIFF(this.liff_id);
    } else if (this.$route.query.type == "medcert") {
      this.liff_id = process.env.VUE_APP_LIFF_ID_MEDCERT;
      await this.initLIFF(this.liff_id);
    } else if (this.$route.query.type == "drug_delivery") {
      this.liff_id = process.env.VUE_APP_LIFF_ID_DRUG_DELIVERRY;
      await this.initLIFF(this.liff_id);
    } else if (this.$route.query.type == "public_relations") {
      this.liff_id = process.env.VUE_APP_LIFF_ID_PUBLIC_RELATIONS;
      await this.initLIFF(this.liff_id);
    } else if (this.$route.query.type == "medical_history") {
      this.liff_id = process.env.VUE_APP_LIFF_ID_MEDICAL_HISTORY;
      await this.initLIFF(this.liff_id);
    }
    // await this.initLIFF();
    // document.getElementById("title").innerHTML = "เลือกโรงพยาบาลหรือคลินิก";
    this.select_clinic = this.item_hospital;
  },
  methods: {
    async initLIFF(item) {
      try {
        await liff.init({ liffId: item });
        if (!liff.isLoggedIn()) {
          liff.login();
        } else {
          const profile = await liff.getProfile();
          this.profile = profile;
          console.log("profile", this.profile);
          await this.checkPatient(this.profile.userId);
          await this.getHospital(this.profile.userId);
        }
      } catch (error) {
        console.error("LIFF initialization failed", error);
      }
    },
    getHospital() {
      try {
        const params = new URLSearchParams();
        params.append("line_user_id", this.profile.userId);
        params.append("search", this.clinic == null ? "" : this.clinic);
        this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/lineoa/choose-biz?${params}`
          )
          .then((res) => {
            // console.log("🚀 ~ .then ~ res:", res);
            if (res.status == 200 && res.data) {
              this.item_hospital = res.data.result;
            }
          });
      } catch (err) {
        console.error();
      }
    },
    checkPatient(item) {
      try {
        this.dialog_loader = true;
        const params = new URLSearchParams();
        params.append("line_user_id", item);
        this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/lineoa/check-patient?${params}`
          )
          .then(async (res) => {
            if (
              res.data.result == "success" &&
              res.data.message == "This user exist."
            ) {
              this.share_token = res.data.data.shared_token;
              // sessionStorage.access_token = this.share_token
              sessionStorage.access_token = await get_access_token(
                res.data.data.shared_token
              );
              this.check_patient = true;
              await this.checkConsent();
              this.dialog_loader = false;
            } else if (res.data.message == "login") {
              let ref_code = res.data.data.responseFromOneid.data.refcode;
              let mobile = res.data.data.patient.mobile;
              this.$router.push(
                `/management/confirm-otp?user_id=${item}&mobile=${mobile}&solution=login&ref_code=${ref_code}&from=select-hospital&type=${this.$route.query.type}`
              );
            } else {
              Swal.fire({
                html: `
              <span style="color: black; font-size: 24px; font-family: Sarabun, sans-serif;">
                <strong>ไม่สามารถเข้าใช้งานระบบได้</strong>
              </span><br>
              <span style="color: black; font-size: 20px; font-family: Sarabun, sans-serif;padding-top: 14px; display: inline-block;">
                เนื่องจากท่านยังไม่ได้ลงทะเบียนเข้าใช้งานระบบ
              </span>
              `,
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                allowOutsideClick: false,
                // cancelButtonColor: "#d33",
                confirmButtonText: "ลงทะเบียน",
                // cancelButtonText: "ยกเลิก",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.$router.push(
                    `/management/register-line?user_id=${this.profile.userId}&username=${this.profile.displayName}&from=select-hospital&type=${this.$route.query.type}`
                  );
                }
              });
            }
            this.dialog_loader = false;
          });
      } catch (err) {
        this.dialog_loader = false;
        console.error();
      }
    },
    async checkConsent() {
      try {
        const params = new URLSearchParams();
        params.append("share_token", this.share_token);
        await this.axios
          .get(process.env.VUE_APP_BACKEND_URL + `/consent/v1/check?${params}`)
          .then(async (res) => {
            if (res.data.result == "success" && res.data.data === true) {
              this.consent = true;
              this.dialog_loader = false;
            } else if (
              res.data.result == "success" &&
              res.data.data === false
            ) {
              this.dialog_loader = false;
              Swal.fire({
                html: `
              <span style="color: black; font-size: 24px; font-family: Sarabun, sans-serif;padding-bottom: 10px; display: inline-block;">
                <strong>ความยินยอม</strong>
              </span><br>
              <span style="color: black; font-size: 20px; font-family: Sarabun, sans-serif;">
                แบบฟอร์มบันทึกความยินยอม
              </span>
              `,
                imageUrl: `${require("@/assets/OnePlatform/Group 11.svg")}`,
                imageWidth: 150,
                imageHeight: 150,
                // icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#32B1EE",
                allowOutsideClick: false,
                // cancelButtonColor: "#d33",
                confirmButtonText: "แบบฟอร์มบันทึกความยินยอม",
                // cancelButtonText: "ยกเลิก",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.itemConsent.share_token = this.share_token;
                  this.$refs.dialogConsent.openDialog(this.share_token);
                }
              });
            } else {
              Swal.fire({
                type: "error",
                width: "auto",
                icon: "error",
                backdrop: false,
                showConfirmButton: false,
                timer: 1000,
              });
            }
          });
      } catch (error) {
        console.log("🚀 ~ error:", error);
        Swal.fire({
          html: `
              <span style="color: black; font-size: 24px; font-family: Sarabun, sans-serif;">
                <strong>ระบบมีปัญหา</strong>
              </span><br>
              <span style="color: black; font-size: 20px; font-family: Sarabun, sans-serif;padding-top: 14px;padding-bottom: 10px; display: inline-block;">
                กรุณาลองใหม่อีกครั้งในภายหลัง
              </span>
              `,
          icon: "error",
          allowOutsideClick: () => {
            const popup = this.$swal.getPopup();
            popup.classList.remove("swal2-show");
            setTimeout(() => {
              popup.classList.add("shake-sweetalert");
            });
            setTimeout(() => {
              popup.classList.remove("shake-sweetalert");
            }, 500);
            return false;
          },
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
      }
    },
    next_step_reserve(clinic) {
      let type = this.$route.query.type;
      if (type == "drug_delivery") {
        this.$router.push(
          `/management/telepharma/CheckUser?business_id=${clinic.biz_id}&use_on=line_oa&share_token=${this.share_token}&type=line_oa`
        );
      } else if (type == "public_relations") {
        this.$router.push(
          `/management/branner/noti?business_id=${clinic.biz_id}&use_on=line_oa&share_token=${this.share_token}&type=line_oa`
        );
      } else if (type == "medical_history") {
        this.$router.push(
          `/management/medical-history?business_id=${clinic.biz_id}&line_user_id=${this.profile.userId}`
        );
      } else {
        this.$router.push(
          `/management/${type}?business_id=${clinic.biz_id}&use_on=line_oa&share_token=${this.share_token}&type=line_oa`
        );
      }
    },
  },
};
</script>

<style scoped>
.bg_color {
  background-color: #e7f7fe;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

::v-deep .theme--light.v-application {
  background-color: #e7f7fe !important;
}
</style>
